import React from 'react';
import { faBars } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const MenuIcon = () => (
  <Icon tooltip="Open and close menu" iconObj={faBars} />
);

export default MenuIcon;